import { gsap } from "gsap"

export default () => {
    const element = document.querySelectorAll<HTMLElement>('.js-star svg')
    const randomY = () => gsap.utils.random(0, 20)
    const randomX = () => gsap.utils.random(0, 30)

    if (element === null) {
        return
    }

    gsap.to(element, {
        translateX() {
            return randomX();
        },
        translateY() {
            return randomY();
        },
        duration: 5,
        ease: "power3.inOut",
        transformOrigin: "center center",
        stagger: {
            yoyo: true,
            repeat: -1,
            each: 0.5,
        }
    });
};